// extracted by mini-css-extract-plugin
module.exports = {"enter":"slidetoUp_enter__dc6wD","enterActive":"slidetoUp_enterActive__2HZ50","exit":"slidetoUp_exit___NA5p","exitActive":"slidetoUp_exitActive__16jB1"};